<template>
  <div class="content-layout">
    <div class="setting-layout">
      <div class="timeout-layout">
        <div class="setting-button" @click="allShow('time')">
          <span
            v-if="tab === '计时结束停止播放' && timestr && setType !== 'time'"
            >{{ timestr }}</span
          >
          <span v-else>计时器</span>
        </div>
      </div>
      <div class="reverberation-layout" @click="allShow('mixes')">
        <div class="setting-button">组合</div>
      </div>
      <div class="share-layout" @click="allShow('share')">
        <div class="setting-button">分享</div>
      </div>
    </div>
    <div
      :class="[
        'setting-main',
        setType === 'time' ? 'settingTimeout' : '',
        setType === 'mixes' ? 'settingMixes' : '',
        setType === 'share' ? 'settingShare' : '',
      ]"
    >
      <SetTimeout
        ref="timeout"
        v-show="setType === 'time'"
        @close="allClose"
        @change="timeNumChange"
      />
      <SetMixes
        ref="mixes"
        v-show="setType === 'mixes'"
        @mixesClose="allClose"
        @saveMixes="saveMixes"
        @deleteMixes="deleteMixes"
        @mixesPlay="mixesPlay"
        @randomMixes="setRandomVolumes"
        @mixesShare="mixesShare"
        :list="mixesList"
      />
      <SetShare
        ref="share"
        v-show="setType === 'share'"
        :currentSound="currentSound"
      />
    </div>
    <div class="play-layout">
      <div
        class="play-button"
        :class="{ stop: allPlay, play: !allPlay }"
        @click="clickPlay"
      >
        <!-- <img src="~@/assets/images/play.png" alt="" /> -->
        <div class="isplay"></div>
      </div>
      <div class="play-info-layout">
        <div class="play-name">轻声细语</div>
        <div class="play-tip">让心灵沉浸在一片宁静之中</div>
      </div>
    </div>
    <div class="music-list-layout">
      <ul class="music-list">
        <li
          class="music-item"
          v-for="(i, x) in musicList"
          :key="x"
          @click="volumeAdd(i)"
        >
          <img :src="i.icon" alt="" />
          <img
            class="solid-imgicon"
            :src="i.solidImageUrl"
            :style="`opacity: ${i.volume / 100}`"
            alt=""
          />
          <span>{{ i.name }}</span>
          <div class="music-slider" @click.stop>
            <WhiteSlider :value="i.volume" @input="inputChange(i, $event)" />
          </div>
          <audio
            v-if="i.audio"
            :ref="i.name"
            class="music-audio"
            loop
            :src="i.audio"
            @timeupdate="onTimeUpdate(i.name)"
          ></audio>
          <audio
            v-if="i.miniAudio"
            :ref="`${i.name}_mini`"
            class="music-mini-audio"
            :src="i.miniAudio"
            @ended="onMiniAudioEnded(i.name)"
          ></audio>
        </li>
      </ul>
      <div class="music-more" v-if="!isVip">
        <div class="more-button" @click="MoreShowChange(true)">更多声音</div>
      </div>

      <!-- <div class="footer-agreement">
        <a href="/agreement/PrivacyStatement" title="隐私政策">隐私政策</a>
        <a class="agreement-button" href="/agreement/TermsOfUse" title="使用条款">使用条款</a>
      </div> -->
      <div class="more-music-layout" v-if="moreShow">
        <MoreMusic @MoreShowChange="MoreShowChange" />
      </div>
    </div>
  </div>
</template>

<script>
import WhiteSlider from '@/components/white-slider/white-slider.vue'
import { GetAudioList, OptionUserSound } from '@/api/index'
import SetTimeout from '../components/set-timeout.vue'
import SetMixes from '../components/set-mixes.vue'
import { audioObjectToString, audioStringToObject } from '@/utils/helper'
import SetShare from '../components/set-share.vue'
import MoreMusic from '../more-music/index.vue'

export default {
  components: { WhiteSlider, SetTimeout, SetMixes, SetShare, MoreMusic },
  name: 'HomeContent',
  data() {
    return {
      musicList: [],
      allPlay: false,
      globalVolume: 1,
      timer: null,
      time: 0,
      timeShow: false,
      timestr: '',
      tab: '',
      mixesList: [],
      setType: '', // time, mixes, share
      currentSound: '',
      threshold: 4, // 距离结束多少秒时触发迷你音频
      moreShow: false,
      userinfo: {}
    }
  },
  watch: {
    '$store.state.userInfo': {
      handler(val, old) {
        this.userinfo = val
        if ((!old && val) || (old && old.vip_time !== val.vip_time)) {
          this.fetchAudioList()
          this.getUserMixes()
        }
      },
      immediate: true,
      deep: true
    },
    '$store.state.volume': {
      handler(newValue) {
        this.globalVolume = newValue / 100
        this.musicList.forEach(item => {
          this.inputChange(item, item.volume)
        })
      },
      deep: true
    },
    '$store.state.payShowType': {
      handler(val) {
        this.moreShow = val > 0
      }
    }
  },
  computed: {
    isVip() {
      return this.userinfo?.user_type === '会员'
    },
    playNameListStr() {
      let list = this.musicList?.filter(i => i.volume > 0).map(i => i.name)
      list = list.length > 0 ? list.join(',') : ''
      return list
    }
  },
  created() {
    const saveList = window.localStorage.getItem('mixesList')
    if (saveList) {
      this.mixesList = JSON.parse(saveList)
    }
    // this.getUserMixes()
  },
  mounted() {
    const query = this.$route?.query
    if (query && query.m) {
      this.allPlay = true
      setTimeout(() => {
        this.mixesPlay({ soundIds: query.m }, 'mounted')
      }, 2000);
    }
  },
  methods: {
    getUserMixes() {
      if (this.userinfo?.id) {
        this.optionUserSet({ option: 0 }, res => {
          if (res.code === 200 && res.data.length > 0) {
            this.mixesList = res.data
            window.localStorage.setItem('mixesList', JSON.stringify(res.data))
          } else if (this.mixesList?.length > 0) {
            const list = this.mixesList.map(i => ({ id: null, name: i.name, soundIds: i.soundIds }))
            this.optionUserSet({ option: 5, list })
          }
        })
      }
    },
    async optionUserSet(data, cb) {
      const res = await OptionUserSound(data)
      if (res.code == 200 && cb) {
        cb(res)
      }
    },
    MoreShowChange(type) {
      this.$MORESOUND01(type ? 1 : 2, '')
      this.moreShow = type
    },
    allClose() {
      this.areaClickReport('', this.setType)
      this.setType = ''
    },
    areaClickReport(type, oldType) {
      // 倒计时混音和分享点击上报
      const refs = this.$refs;

      const actions = {
        time: (flag) => this.$TIMER01(flag, refs?.timeout?.totalSeconds, refs?.timeout?.tab),
        mixes: (flag) => this.$COMBO01(flag, ''),
        share: (flag) => this.$SHARE01(flag, refs?.share?.currentSoundUrl)
      };

      let flag = 1;
      let currentType = type;

      if (type === '') {
        flag = 2;
        currentType = oldType;
      }

      const action = actions[currentType];
      if (action) {
        action(flag);
      }
    },
    allShow(type) {
      const oldtype = this.setType
      this.setType = this.setType === type ? '' : type
      this.areaClickReport(this.setType, oldtype)
      if (type === 'share') {
        this.currentSound = audioObjectToString(this.musicList)
      }
    },
    mixesShare(item) {
      if (item && item.soundIds) {
        this.setType = 'share'
        this.currentSound = item.soundIds
      }
    },
    mixesPlay(item, clicktype) {
      if (item && item.soundIds) {
        const newlist = audioStringToObject(item.soundIds)
        const list = this.updateVolumes(this.musicList, newlist)
        this.musicList = list
        if (clicktype !== 'mounted') {
          this.$COMBO01(4, this.playNameListStr)
        }
        this.$nextTick(() => {
          this.allPlayChange('play')
        })
      }
    },
    setRandomVolumes() {
      // 随机选择2到8个音频
      const count = Math.floor(Math.random() * 7) + 2;
      const selectedAudios = [];

      // 生成不重复的随机索引
      while (selectedAudios.length < count) {
        const index = Math.floor(Math.random() * this.musicList.length);
        if (!selectedAudios.includes(index)) {
          selectedAudios.push(index);
        }
      }

      // 设置所有音频音量为0
      for (let i = 0; i < this.musicList.length; i++) {
        this.musicList[i].volume = 0;
      }

      // 设置选中音频的音量
      selectedAudios.forEach(index => {
        const volume = Math.floor(Math.random() * 99) + 1; // 1到100之间的随机音量
        this.musicList[index].volume = volume;
      });
      this.$COMBO01(3, this.playNameListStr)
      this.$nextTick(() => {
        this.allPlayChange('play')
      })
    },
    /**
     * 根据分享数据的音量来替换原有数据中的音量
     * 
     * @param {Array} originalData - 原始数据数组
     * @param {Array} shareData - 分享数据数组
     * @returns {Array} - 替换后的数据数组
     */
    updateVolumes(originalData, shareData) {
      // 创建一个映射表，用于快速查找分享数据中的音量
      const shareVolumeMap = new Map();
      shareData.forEach(item => {
        shareVolumeMap.set(item.id, item.volume);
      });

      // 遍历原始数据并更新音量
      return originalData.map(item => {
        const newVolume = shareVolumeMap.has(item.id) ? shareVolumeMap.get(item.id) : 0;
        return { ...item, volume: newVolume };
      });
    },
    deleteMixes({ list, item }) {
      window.localStorage.setItem('mixesList', JSON.stringify(list))
      if (this.userinfo?.id && item.id) {
        this.optionUserSet({ option: 3, id: item.id })
      }
    },
    saveMixes(name) {
      const saveList = this.musicList.filter(i => (i.volume && i.volume > 0)).map(item => ({ id: item.id, volume: item.volume }))
      this.$COMBO01(5, this.playNameListStr, name)
      const str = audioObjectToString(saveList)
      const saveData = {
        name,
        soundIds: str
      }
      this.mixesList.unshift(saveData)
      window.localStorage.setItem('mixesList', JSON.stringify(this.mixesList))
      if (this.userinfo?.id) {
        const data = {
          option: 1,
          id: null,
          ...saveData
        }
        this.optionUserSet(data)
      }
    },
    updateAudioPlayback(time, tab) {
      if (tab === '计时结束停止播放') {
        if (time === '00:00:00') {
          if (this.allPlay) {
            this.allPlayChange();
          }
        } else {
          if (!this.allPlay) {
            this.allPlayChange();
          }
        }
      } else if (tab === '计时结束开始播放') {
        if (time === '00:00:00') {
          if (!this.allPlay) {
            this.allPlayChange();
          }
        } else {
          if (this.allPlay) {
            this.allPlayChange();
          }
        }
      }
    },
    timeNumChange(val) {
      if (val) {
        const { time, tab } = val
        this.timestr = time === '00:00:00' ? '' : time
        this.tab = tab
        this.updateAudioPlayback(time, tab)
      }
    },
    itemVolumeChange(audio, volume) {
      if (volume <= 0 || this.globalVolume <= 0) {
        audio.volume = 0
      } else {
        audio.volume = parseFloat((volume / 100 * this.globalVolume).toFixed(2))
      }
    },
    async fetchAudioList() {
      try {
        const res = await GetAudioList({ pageSize: 99 })
        if (res.code === 200 && res.data?.list?.length > 0) {
          this.musicList = res.data.list.map((i, x) => {
            return {
              ...i,
              volume: x === 0 ? 60 : 0,
              isplay: false,
              icon: i.avatarUrl,
              audio: i.mainSoundUrl,
              miniAudio: i.soundUrl
            }
          })
        }
      } catch (error) {
        console.error('获取音频列表失败:', error)
      }
    },
    volumeAdd(i) {
      const audio = this.$refs[i.name][0]
      if (i.volume === 100) {
        i.volume = 0
      } else {
        i.volume += 20
        if (i.volume > 100) {
          i.volume = 100
        }
      }
      // audio.volume = i.volume / 100
      this.itemVolumeChange(audio, i.volume)
    },
    clickPlay() {
      // 点击播放按钮上报
      this.$PLAY01(!this.allPlay, this.playNameListStr)
      this.allPlayChange()
    },
    allPlayChange(play) {
      this.allPlay = play === 'play' ? true : !this.allPlay
      // 缓存音乐列表和对应的音频元素
      const musicList = this.musicList;
      const audioRefs = this.$refs;

      musicList.forEach((item) => {
        item.isplay = this.allPlay;

        // 获取音频元素
        const audioElement = audioRefs[item.name]?.[0];
        const miniAudioElement = audioRefs[`${item.name}_mini`]?.[0];
        if (!audioElement || !miniAudioElement) return; // 如果音频元素不存在，则跳过

        try {
          // audioElement.volume = item.volume / 100;
          this.itemVolumeChange(audioElement, item.volume)
          this.itemVolumeChange(miniAudioElement, item.volume);
          if (this.allPlay) {
            audioElement.play();
            miniAudioElement.play();
          } else {
            audioElement.pause();
            miniAudioElement.pause();
          }
        } catch (error) {
          console.error('Failed to play/pause audio:', error);
        }
      });
    },
    playMusic(item) {
      const audio = this.$refs[item.name][0]
      if (audio) {
        // const volume = item.volume / 100
        // audio.volume = volume
        this.itemVolumeChange(audio, item.volume)
        if (audio.paused) {
          audio.play()
          item.isplay = true
        } else {
          audio.pause()
          item.isplay = false
        }
      }
    },
    inputChange(item, value) {
      item.volume = value
      if (this.setType === 'share') {
        this.currentSound = audioObjectToString(this.musicList)
      }
      const audio = this.$refs[item.name][0]
      if (audio) {
        // const volume = item.volume / 100
        // audio.volume = volume
        this.itemVolumeChange(audio, item.volume)
      }
    },

    onTimeUpdate(audioName) {
      const mainAudio = this.$refs[audioName][0];
      const miniAudio = this.$refs[`${audioName}_mini`][0];

      if (mainAudio.duration - mainAudio.currentTime <= this.threshold) {
        if (!miniAudio.paused) return; // 如果迷你音频已经在播放，不重复播放
        miniAudio.play().catch(error => {
          console.error('Failed to play mini audio:', error);
        });
      }
      // 同步音量
      miniAudio.volume = mainAudio.volume;
    },
    onMiniAudioEnded(audioName) {
      const miniAudio = this.$refs[`${audioName}_mini`][0];
      miniAudio.pause();
      miniAudio.currentTime = 0;
    },
  }
}
</script>

<style lang='less' scoped>
.content-layout {
  width: 100%;
  // min-height: 101vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 0.3rem;
  .setting-layout {
    height: 0.32rem;
    display: flex;
    margin-bottom: 0.3rem;
    .setting-button {
      width: 1.58rem;
      height: 0.32rem;
      border-radius: 0.04rem;
      border: 1px solid rgba(255, 255, 255, 0.19);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 0.14rem;
      cursor: pointer;
      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
    .reverberation-layout .setting-button {
      margin: 0 0.56rem;
    }
  }
  .play-layout {
    display: flex;
    width: 5.86rem;
    height: 1.1rem;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.8rem;
    margin-top: 0.42rem;
    .play-button {
      width: 0.8rem;
      height: 0.8rem;
      margin-right: 0.6rem;
      cursor: pointer;
      // img {
      //   width: 100%;
      // }
      .isplay {
        transition: border 0.15s linear, opacity 0.1s;
      }
    }
    .stop .isplay {
      border: 0 solid transparent;
      border-left: 0.256rem solid #fff;
      border-right: 0.256rem solid #fff;
      width: 0.72rem;
      height: 0.72rem;
    }
    .play .isplay {
      border: 0.4rem solid transparent;
      border-left: 0.72rem solid #fff;
      border-right: 0 solid #fff;
      width: 0.8rem;
      height: 0.8rem;
    }
    .play-info-layout {
      height: 1.1rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #ffffff;
      .play-name {
        font-size: 0.48rem;
        font-weight: bold;
        margin-bottom: 0.1rem;
      }
      .play-tip {
        font-size: 0.16rem;
        text-align: center;
      }
    }
  }
  .music-list-layout {
    max-width: 8.7rem;
    width: 100%;
    margin: 0 auto;
    .music-list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      font-size: 0.16rem;
      .music-item {
        width: 1.5rem;
        height: 1.5rem;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 0.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 0.12rem 0.3rem;
        cursor: pointer;
        position: relative;
        img {
          width: 0.55rem;
          height: 0.55rem;
          object-fit: cover;
          border-radius: 50%;
        }
        .solid-imgicon {
          position: absolute;
          top: 0.11rem;
        }
        > span {
          margin-top: 0.1rem;
        }
        .music-slider {
          display: flex;
          justify-content: center;
          width: 100%;
          margin-top: 0.15rem;
          cursor: default;
          .white-slider {
            width: 0.8rem;
          }
        }
        .music-audio {
          display: none;
        }
        .music-mini-audio {
          display: none;
        }
      }
    }

    .music-more {
      text-align: center;
      margin: 0.2rem 0;
      .more-button {
        cursor: pointer;
        width: 1.28rem;
        height: 0.32rem;
        border-radius: 0.04rem;
        border: 1px solid rgba(255, 255, 255, 0.29);
        line-height: 0.32rem;
        text-align: center;
        margin: 0 auto;
        &:hover {
          background-color: #fff;
          color: #111;
        }
      }
    }
  }

  .setting-main {
    width: 5.86rem;
    height: 0;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 0.04rem;
    transition: height 0.3s;
    margin-top: 0.2rem;
  }
  .settingTimeout {
    height: 2.85rem;
  }
  .settingMixes {
    height: 3.8rem;
  }
  .settingShare {
    height: 2rem;
  }

  .footer-agreement {
    max-width: 4.8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    > a {
      font-size: 0.16rem;
      color: #fff;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>